var map = {
	"./views/AllDocument": [
		"8f3a",
		"chunk-b5033794"
	],
	"./views/AllDocument.vue": [
		"8f3a",
		"chunk-b5033794"
	],
	"./views/AllVideo": [
		"b47d",
		"chunk-0449dcfa"
	],
	"./views/AllVideo.vue": [
		"b47d",
		"chunk-0449dcfa"
	],
	"./views/Download": [
		"3971",
		"chunk-3589158e"
	],
	"./views/Download.vue": [
		"3971",
		"chunk-3589158e"
	],
	"./views/Novice": [
		"42b5",
		"chunk-99389730"
	],
	"./views/Novice.vue": [
		"42b5",
		"chunk-99389730"
	],
	"./views/NoviceDetail": [
		"320d",
		"chunk-1e3376f7"
	],
	"./views/NoviceDetail.vue": [
		"320d",
		"chunk-1e3376f7"
	],
	"./views/Question": [
		"e2540",
		"chunk-1a4e7b47"
	],
	"./views/Question.vue": [
		"e2540",
		"chunk-1a4e7b47"
	],
	"./views/QuestionContents": [
		"cf48",
		"chunk-2d22271d"
	],
	"./views/QuestionContents.vue": [
		"cf48",
		"chunk-2d22271d"
	],
	"./views/QuestionDetail": [
		"51b6",
		"chunk-09943acf"
	],
	"./views/QuestionDetail.vue": [
		"51b6",
		"chunk-09943acf"
	],
	"./views/SearchResult": [
		"9820",
		"chunk-51d6738b"
	],
	"./views/SearchResult.vue": [
		"9820",
		"chunk-51d6738b"
	],
	"./views/Video": [
		"81a8",
		"chunk-2d0dd9a6"
	],
	"./views/Video.vue": [
		"81a8",
		"chunk-2d0dd9a6"
	],
	"./views/VideoDetail": [
		"b96c",
		"chunk-0add109f"
	],
	"./views/VideoDetail.vue": [
		"b96c",
		"chunk-0add109f"
	],
	"./views/VideoList": [
		"f0d0",
		"chunk-aaadafce"
	],
	"./views/VideoList.vue": [
		"f0d0",
		"chunk-aaadafce"
	],
	"./views/document": [
		"557c",
		"chunk-2ed1c40e"
	],
	"./views/document.vue": [
		"557c",
		"chunk-2ed1c40e"
	],
	"./views/feedback": [
		"c6bd",
		"chunk-28612352"
	],
	"./views/feedback.vue": [
		"c6bd",
		"chunk-28612352"
	],
	"./views/pages_wap": [
		"b2d6",
		"chunk-2d20f558"
	],
	"./views/pages_wap/": [
		"b2d6",
		"chunk-2d20f558"
	],
	"./views/pages_wap/AllDocument": [
		"e6b9",
		"chunk-a55ef4ac"
	],
	"./views/pages_wap/AllDocument.vue": [
		"e6b9",
		"chunk-a55ef4ac"
	],
	"./views/pages_wap/AllVideo": [
		"182e",
		"chunk-2b622f66"
	],
	"./views/pages_wap/AllVideo.vue": [
		"182e",
		"chunk-2b622f66"
	],
	"./views/pages_wap/Download": [
		"ecc1",
		"chunk-715ad6e6"
	],
	"./views/pages_wap/Download.vue": [
		"ecc1",
		"chunk-715ad6e6"
	],
	"./views/pages_wap/Search": [
		"a2a7",
		"chunk-ff167c98"
	],
	"./views/pages_wap/Search.vue": [
		"a2a7",
		"chunk-ff167c98"
	],
	"./views/pages_wap/SearchResult": [
		"ec6c",
		"chunk-63a46e03"
	],
	"./views/pages_wap/SearchResult.vue": [
		"ec6c",
		"chunk-63a46e03"
	],
	"./views/pages_wap/feedback": [
		"fce2",
		"chunk-32eca3c6"
	],
	"./views/pages_wap/feedback.vue": [
		"fce2",
		"chunk-32eca3c6"
	],
	"./views/pages_wap/getToken": [
		"a94a",
		"chunk-8e3fe0e6"
	],
	"./views/pages_wap/getToken.vue": [
		"a94a",
		"chunk-8e3fe0e6"
	],
	"./views/pages_wap/index": [
		"b2d6",
		"chunk-2d20f558"
	],
	"./views/pages_wap/index.vue": [
		"b2d6",
		"chunk-2d20f558"
	],
	"./views/pages_wap/novice": [
		"b1a1",
		"chunk-6b9c5671"
	],
	"./views/pages_wap/novice/": [
		"b1a1",
		"chunk-6b9c5671"
	],
	"./views/pages_wap/novice/NoviceDetail": [
		"3fbc",
		"chunk-0ddc1e18"
	],
	"./views/pages_wap/novice/NoviceDetail.vue": [
		"3fbc",
		"chunk-0ddc1e18"
	],
	"./views/pages_wap/novice/index": [
		"b1a1",
		"chunk-6b9c5671"
	],
	"./views/pages_wap/novice/index.vue": [
		"b1a1",
		"chunk-6b9c5671"
	],
	"./views/pages_wap/question": [
		"9a15",
		"chunk-2d0efc62"
	],
	"./views/pages_wap/question/": [
		"9a15",
		"chunk-2d0efc62"
	],
	"./views/pages_wap/question/QuestionContents": [
		"acb4",
		"chunk-a89c62b2"
	],
	"./views/pages_wap/question/QuestionContents.vue": [
		"acb4",
		"chunk-a89c62b2"
	],
	"./views/pages_wap/question/QuestionDetail": [
		"26d4",
		"chunk-58cd4b10"
	],
	"./views/pages_wap/question/QuestionDetail.vue": [
		"26d4",
		"chunk-58cd4b10"
	],
	"./views/pages_wap/question/index": [
		"9a15",
		"chunk-2d0efc62"
	],
	"./views/pages_wap/question/index.vue": [
		"9a15",
		"chunk-2d0efc62"
	],
	"./views/pages_wap/video": [
		"b6a2",
		"chunk-2d2103fb"
	],
	"./views/pages_wap/video/": [
		"b6a2",
		"chunk-2d2103fb"
	],
	"./views/pages_wap/video/VideoDetail": [
		"71e5",
		"chunk-4f093ca5"
	],
	"./views/pages_wap/video/VideoDetail.vue": [
		"71e5",
		"chunk-4f093ca5"
	],
	"./views/pages_wap/video/VideoList": [
		"6079",
		"chunk-0a02d845"
	],
	"./views/pages_wap/video/VideoList.vue": [
		"6079",
		"chunk-0a02d845"
	],
	"./views/pages_wap/video/index": [
		"b6a2",
		"chunk-2d2103fb"
	],
	"./views/pages_wap/video/index.vue": [
		"b6a2",
		"chunk-2d2103fb"
	],
	"./views/videoPlayer": [
		"cf8f",
		"chunk-2d2227c7"
	],
	"./views/videoPlayer.vue": [
		"cf8f",
		"chunk-2d2227c7"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "2a68";
module.exports = webpackAsyncContext;